
import moment from 'moment';
import qs from 'qs';

const Toast = console;

const API_ENDPOINT = 'https://crm.mangomist.com/';
export class RESTClient{

    constructor(slug){
        this.slug = slug
    }

    async get(url){
        let result = await fetch(API_ENDPOINT+url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...this.auth()
            }
        })
        if(result.headers.get('content-type').indexOf('application/json') == 0){
            result = await result.json();
            if(!result.error) {
                return result;
            }else{
                result.message.forEach(msg => {
                    msg.messages.forEach(m => {
                        Toast.error(m.message)
                    })
                })
            }
        }else{
            // result = await result.blob();
            // saveAs(result, moment().format('YYYY-MM-DD-HH-mm')+'.xlsx');
            // return true;
        }
    }

    async post(url, data){
        let result = await fetch(API_ENDPOINT+url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...this.auth()
            },
            body: JSON.stringify(data)
        })
        result = await result.json();
        if(!result.error) {
            return result;
        }else{
            result.message.forEach(msg => {
                msg.messages.forEach(m => {
                    Toast.error(m.message)
                })
            })
        }
    }

    async put(url, data){
        let result = await fetch(API_ENDPOINT+url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...this.auth()
            },
            body: JSON.stringify(data)
        })
        result = await result.json();
        if(!result.error) {
            return result;
        }else{
            result.message.forEach(msg => {
                msg.messages.forEach(m => {
                    Toast.error(m.message)
                })
            })
        }
    }

    async delete(url){
        let result = await fetch(API_ENDPOINT+url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                ...this.auth()
            }
        })
        result = await result.json();
        if(!result.error) {
            return result;
        }else{
            result.message.forEach(msg => {
                msg.messages.forEach(m => {
                    Toast.error(m.message)
                })
            })
        }
    }

    auth(){
        if(window.localStorage.getItem('token')){
            return {
                'Authorization': 'Bearer '+ JSON.parse(window.localStorage.getItem('token'))
            }
        }else if(this.authToken){
            return {
                'Authorization': 'Bearer '+this.authToken
            }
        }else
        return {};
    }

    async find(query, fields, limit, skip){
        if(query){
            let qbuilder = {
                _where: query
            };
            if(limit)
            qbuilder._limit = limit;
            if(skip)
            qbuilder._start = skip;
            const q = qs.stringify(qbuilder)
            return this.get(`${this.slug}?${q}`);
        }else
        return this.get(this.slug);
    }

    async create(data){
        return this.post(this.slug, data);
    }

    async update(id, data){
        return this.put(`${this.slug}/${id}`, data);
    }

    async findOne(query, fields){
        let qbuilder = {};
        if(query)
        qbuilder._where = query
        qbuilder._limit = 1;
        const q = qs.stringify(qbuilder)
        let res =  await this.get(`${this.slug}?${q}`);
        if(res && res.length)
        return res[0];
        else
        return null;
    }

    async count(query){
        if(query){
            let qbuilder = {
                _where: query
            };
            const q = qs.stringify(qbuilder)
            return this.get(`${this.slug}/count?${q}`);
        }else
        return this.get(`${this.slug}/count`);
    }

    async findById(id){
        return this.get(`${this.slug}/${id}`);
    }

    async search(q){
        return this.get(`${this.slug}?_q=${q}`);
    }

    async updateById(id, data){
        return this.put(`${this.slug}/${id}`, data);
    }
}

export const REST = new RESTClient();